import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { FaRegClock } from 'react-icons/fa';
import { FaAngleRight } from 'react-icons/fa';
import { LuHeart } from 'react-icons/lu';
import { FaRegFileAlt } from 'react-icons/fa';
import { RxPencil2 } from 'react-icons/rx';
import { FaHeart } from 'react-icons/fa';
import { FiEdit2 } from 'react-icons/fi';
import { FiTrash2 } from 'react-icons/fi';
import { FaBookmark } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { getMyBookRecords, getMyBookByBookId, getTotalRecord, getMyBookMemos, deleteMyBookRecord } from '../api/BookcaseApi';
import { getAccessToken } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';
import { formatTime } from '../common/utils';
import LoadingOverlay from '../components/LoadingOverlay';
import { ErrorContainer, ErrorMessage } from '../components/ErrorContainer';
import { RecordType } from '../common/enums';
import BookRecordPage from './BookRecordPage';

const sampleBookData = {
  id: 'harvard430',
  title: '하버드 새벽 4시반',
  author: '웨이슈잉 / 정민미디어',
  period: '2024. 10. 01 ~ 2024. 10. 25',
  dday: 'D-22',
  badge: '서평단 책',
  cover: '/book_sample.jpg',
  myScore: 5.0,
  readPage: 82,
  memoCount: 8,
};

// 샘플 독서 기록 데이터
const sampleReadingRecords = [
  {
    date: '2025.03.11(월)',
    totalTime: '1시간 26분 12초',
    readTime: 'AM 10:45 ~ PM 12:09',
    readPage: 15
  },
  {
    date: '2025.03.10(일)',
    totalTime: '2시간 15분 30초',
    readTime: 'PM 02:30 ~ PM 04:45',
    readPage: 25
  },
  {
    date: '2025.03.08(금)',
    totalTime: '45분 18초',
    readTime: 'PM 08:15 ~ PM 09:00',
    readPage: 8
  },
  {
    date: '2025.03.05(화)',
    totalTime: '1시간 52분 45초',
    readTime: 'AM 09:20 ~ AM 11:12',
    readPage: 20
  }
];

const PageWrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background: #393939;
`;
const BookInfoBox = styled.div`
  background: #393939;
  padding: 32px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const BookInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0 8px 0;
`;
const Title = styled.div`
  font-size: 17px;
  font-weight: 500;
  color: #fff;
  margin-top: 8px;
  margin-bottom: 2px;
`;
const Period = styled.div`
  font-size: 13px;
  color: #bbb;
  margin-bottom: 10px;
`;
const TotalTimeBox = styled.div`
  margin-top: 8px;
  background: #244ac2;
  border-radius: 16px;
  padding: 6px 18px 6px 14px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
const TimerIcon = styled.span`
  display: flex;
  align-items: center;
  margin-right: 4px;
`;
const TotalTimeText = styled.span`
  color: #fff;
  font-size: 15px;
  font-weight: 500;
`;
const HistoryText = styled.div`
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  margin-top: 6px;
`;

const TabRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #eae8e9;
  border-bottom: 1px solid #ccc;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  gap: 16px;
  padding-left: 20px;
`;
const TabBtn = styled.button`
  background: none;
  border: none;
  color: ${props => props.active ? '#222' : '#555'};
  font-size: 17px;
  font-weight: ${props => props.active ? '700' : '400'};
  padding: 16px 12px 12px 12px;
  border-bottom: 3px solid ${props => props.active ? '#222' : 'transparent'};
  cursor: pointer;
  transition: color 0.2s, border-bottom 0.2s;
`;
const TabContent = styled.div`
  background: #eae8e9;
  color: #222;
  min-height: 200px;
  height: 60vh;
  overflow-y: auto;
  padding: 32px 20px 40px 20px;
`;

const RecordItem = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  position: relative;
`;
const RecordDate = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin-bottom: 8px;
  padding-right: 36px;
`;
const RecordTotalTime = styled.div`
  font-size: 15px;
  color: #555;
  margin-bottom: 6px;
`;
const RecordReadTime = styled.div`
  font-size: 15px;
  color: #777;
  display: flex;
  align-items: center;
  gap: 8px;
`;
const RecordDeleteButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: color 0.2s, background-color 0.2s;

  &:hover {
    color: #e23a3a;
    background: #f5f5f5;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
const BookmarkIcon = styled.span`
  display: flex;
  align-items: center;
  color: #e23a3a;
`;
const ReadPageText = styled.span`
  font-size: 15px;
  color: #e23a3a;
`;

const MemoItem = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
`;
const MemoContent = styled.div`
  font-size: 15px;
  color: #555;
  line-height: 1.5;
  margin-bottom: 8px;
`;
const MemoDate = styled.div`
  font-size: 13px;
  color: #888;
  text-align: right;
`;

export default function BookHistoryPage({propBookId = null, onClose = null}) {
  const [tab, setTab] = useState('record');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [bookData, setBookData] = useState(null);
  const [records, setRecords] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [totalReadTime, setTotalReadTime] = useState(0);
  const [totalReadCnt, setTotalReadCnt] = useState(0);
  
  // 메모 관련 state
  const [memos, setMemos] = useState([]);
  const [memoCurrentPage, setMemoCurrentPage] = useState(0);
  const [memoHasMore, setMemoHasMore] = useState(true);
  const [memoLoadingMore, setMemoLoadingMore] = useState(false);
  const [totalMemos, setTotalMemos] = useState(0);
  const [deletingRecordId, setDeletingRecordId] = useState(null);
  
  const { bookId:argBookId } = useParams();
  const [bookId, setBookId] = useState(propBookId ? propBookId : argBookId);
  const PAGE_SIZE = 20;
  const tabContentRef = useRef(null);

  // 탭 변경 핸들러
  const handleTabChange = (newTab) => {
    setTab(newTab);
    // 탭 변경 시 스크롤 위치 초기화
    if (tabContentRef.current) {
      tabContentRef.current.scrollTop = 0;
    }
  };

  // 초기 데이터 로드
  useEffect(() => {
    const loadInitialData = async () => {
      if (!bookId) return;
      
      setLoading(true);
      try {
        const { accessToken } = await getAccessToken();
        
        // 책 정보 로드
        const bookResponse = await getMyBookByBookId(accessToken || '', parseInt(bookId));
        const processedBookResponse = processApiResponse(bookResponse);
        
        if (!processedBookResponse.success) {
          setError(processedBookResponse.errorMessage);
          return;
        }
        
        setBookData(processedBookResponse.data);

        // 총 독서 시간 조회
        const totalResponse = await getTotalRecord(accessToken || '', parseInt(bookId), RecordType.READING);
        const processedTotalResponse = processApiResponse(totalResponse);
        
        if (processedTotalResponse.success) {
          setTotalReadTime(processedTotalResponse.data.totalTimeInSec || 0);
          setTotalReadCnt(processedTotalResponse.data.totalCnt || 0);
        } else {
          console.error('총 독서 시간 조회 실패:', processedTotalResponse.errorMessage);
        }
        
        // 첫 페이지 독서 기록 로드
        const recordsResponse = await getMyBookRecords(accessToken || '', parseInt(bookId), RecordType.READING, 0, PAGE_SIZE);
        const processedRecordsResponse = processApiResponse(recordsResponse);
        
        if (processedRecordsResponse.success) {
          setRecords(processedRecordsResponse.data || []);
          setHasMore(processedRecordsResponse.page.current < processedRecordsResponse.page.last);
          setCurrentPage(processedRecordsResponse.page.current);
        } else {
          setError(processedRecordsResponse.errorMessage);
        }
        
        // 첫 페이지 메모 로드
        const memosResponse = await getMyBookMemos(accessToken || '', parseInt(bookId), 0, PAGE_SIZE);
        const processedMemosResponse = processApiResponse(memosResponse);
        
        if (processedMemosResponse.success) {
          setMemos(processedMemosResponse.data || []);
          setMemoHasMore(processedMemosResponse.page.current < processedMemosResponse.page.last);
          setMemoCurrentPage(processedMemosResponse.page.current);
          setTotalMemos(processedMemosResponse.page.total);
        } else {
          console.error('메모 로드 실패:', processedMemosResponse.errorMessage);
        }
        
      } catch (error) {
        console.error('데이터 로드 중 오류:', error);
        setError('네트워크 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    };
    
    loadInitialData();
  }, [bookId]);

  // 스크롤 이벤트 핸들러
  const handleScroll = useCallback((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 100) {
      if (tab === 'record' && hasMore && !loadingMore) {
        // 독서 기록 더 로드
        (async () => {
          if (!hasMore || loadingMore) return;
          
          setLoadingMore(true);
          try {
            const { accessToken } = await getAccessToken();
            const nextPage = currentPage + 1;
            
            const recordsResponse = await getMyBookRecords(accessToken || '', parseInt(bookId), RecordType.READING, nextPage, PAGE_SIZE);
            const processedRecordsResponse = processApiResponse(recordsResponse);
            
            if (processedRecordsResponse.success) {
              const newRecords = processedRecordsResponse.data || [];
              setRecords(prev => [...prev, ...newRecords]);
              setCurrentPage(processedRecordsResponse.page.current);
              setHasMore(processedRecordsResponse.page.current < processedRecordsResponse.page.last);
            } else {
              console.error('독서 기록 로드 실패:', processedRecordsResponse.errorMessage);
            }
            
          } catch (error) {
            console.error('독서 기록 로드 중 오류:', error);
          } finally {
            setLoadingMore(false);
          }
        })();
      } else if (tab === 'memo' && memoHasMore && !memoLoadingMore) {
        // 메모 더 로드
        (async () => {
          if (!memoHasMore || memoLoadingMore) return;
          
          setMemoLoadingMore(true);
          try {
            const { accessToken } = await getAccessToken();
            const nextPage = memoCurrentPage + 1;
            
            const memosResponse = await getMyBookMemos(accessToken || '', parseInt(bookId), nextPage, PAGE_SIZE);
            const processedMemosResponse = processApiResponse(memosResponse);
            
            if (processedMemosResponse.success) {
              const newMemos = processedMemosResponse.data || [];
              setMemos(prev => [...prev, ...newMemos]);
              setMemoCurrentPage(processedMemosResponse.page.current);
              setMemoHasMore(processedMemosResponse.page.current < processedMemosResponse.page.last);
            } else {
              console.error('메모 로드 실패:', processedMemosResponse.errorMessage);
            }
            
          } catch (error) {
            console.error('메모 로드 중 오류:', error);
          } finally {
            setMemoLoadingMore(false);
          }
        })();
      }
    }
  }, [tab, hasMore, loadingMore, currentPage, bookId, memoHasMore, memoLoadingMore, memoCurrentPage]);

  // 로딩 중이거나 에러가 있는 경우 처리
  if (loading) {
    return (
      <>
        <div style={{background:'#393939', minHeight:'100vh'}} />
        <LoadingOverlay isLoading={loading} />
      </>
    );
  }

  if (error || !bookData) {
    return (
      <ErrorContainer>
        <ErrorMessage>{error || '책 정보를 찾을 수 없습니다.'}</ErrorMessage>
      </ErrorContainer>
    );
  }

  const handleDeleteRecord = async (recordId) => {
    if (!recordId || deletingRecordId) return;
    if (!window.confirm('이 독서 기록을 삭제하시겠습니까?')) return;

    setDeletingRecordId(recordId);
    try {
      const { accessToken } = await getAccessToken();
      const response = await deleteMyBookRecord(accessToken || '', recordId);
      const processedResponse = processApiResponse(response);
      if (processedResponse.success) {
        setRecords(prev => prev.filter(record => record.id !== recordId));
        setTotalReadCnt(prev => Math.max(0, prev - 1));

        const totalResponse = await getTotalRecord(accessToken || '', parseInt(bookId), RecordType.READING);
        const processedTotalResponse = processApiResponse(totalResponse);
        if (processedTotalResponse.success) {
          setTotalReadTime(processedTotalResponse.data.totalTimeInSec || 0);
          setTotalReadCnt(processedTotalResponse.data.totalCnt || 0);
        }
      } else {
        alert(processedResponse.errorMessage || '기록 삭제에 실패했습니다.');
      }
    } catch (err) {
      console.error('기록 삭제 중 오류:', err);
      alert('기록 삭제 중 오류가 발생했습니다.');
    } finally {
      setDeletingRecordId(null);
    }
  };

  // API 데이터를 기존 sampleBookData 형식으로 변환
  const transformedData = {
    id: bookData.id,
    title: bookData.title,
    author: bookData.author + ' / ' + bookData.publisher,
    period: bookData.readFr + ' ~ ' + bookData.readTo,
    cover: bookData.cover,
    readPage: bookData.readPage || 0,
    pageNum: bookData.pageNum || 0
  };

  // 날짜 포맷팅 함수
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
    const weekday = weekdays[date.getDay()];
    return `${year}.${month}.${day}(${weekday})`;
  };

  // 시간 포맷팅 함수
  const formatReadTime = (startAt, endAt) => {
    const start = new Date(startAt);
    const end = new Date(endAt);
    
    const formatTime = (date) => {
      const hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const period = hours < 12 ? 'AM' : 'PM';
      const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
      return `${period} ${displayHours}:${minutes}`;
    };
    
    return `${formatTime(start)} ~ ${formatTime(end)}`;
  };

  // 읽은 페이지 퍼센트 계산
  const calculateReadPercentage = (readPage, totalPage) => {
    if (!totalPage || totalPage === 0) return 0;
    return Math.round((readPage / totalPage) * 100);
  };

  return (
    <PageWrapper>
      <BookInfoBox>
        <BookInfoContent>
          <Title>{transformedData.title}</Title>
          <Period>{transformedData.period}</Period>
          <TotalTimeBox>
            <TimerIcon><FaRegClock size={18} color="#fff" /></TimerIcon>
            <TotalTimeText>{formatTime(totalReadTime)}</TotalTimeText>
          </TotalTimeBox>
          <HistoryText><FaAngleRight size={10} color="#fff" style={{marginRight:4, verticalAlign:'middle'}} />독서 이력 {totalReadCnt}회</HistoryText>
        </BookInfoContent>
      </BookInfoBox>
      <TabRow>
        <TabBtn active={tab==='record'} onClick={()=>handleTabChange('record')}>기록</TabBtn>
        <TabBtn active={tab==='memo'} onClick={()=>handleTabChange('memo')}>메모</TabBtn>
      </TabRow>
      <TabContent 
        ref={tabContentRef}
        onScroll={handleScroll}
      >
        {tab === 'record' ? (
          <div>
            {records.length > 0 ? (
              <>
                {records.map((record, index) => (
                  <RecordItem key={record.id ?? index}>
                    <RecordDeleteButton
                      onClick={() => handleDeleteRecord(record.id)}
                      disabled={deletingRecordId === record.id}
                      aria-label="기록 삭제"
                    >
                      <FiTrash2 size={16} />
                    </RecordDeleteButton>
                    <RecordDate>{formatDate(record.createdAt)}</RecordDate>
                    <RecordTotalTime>{formatTime((new Date(record.endAt) - new Date(record.startAt)) / 1000)}</RecordTotalTime>
                    <RecordReadTime>
                      {formatReadTime(record.startAt, record.endAt)}
                      <BookmarkIcon><FaBookmark size={12} /></BookmarkIcon>
                      <ReadPageText>{calculateReadPercentage(transformedData.readPage, transformedData.pageNum)}%</ReadPageText>
                    </RecordReadTime>
                  </RecordItem>
                ))}
                {loadingMore && <LoadingOverlay isLoading={loadingMore} />}
              </>
            ) : (
              <div style={{textAlign: 'center', color: '#888', padding: '40px 0'}}>
                아직 독서 기록이 없습니다.
              </div>
            )}
          </div>
        ) : (
          <div>
            {memos.length > 0 ? (
              <>
                {memos.map((memo, index) => (
                  <MemoItem key={index}>
                    <MemoContent>{memo.memo}</MemoContent>
                    <MemoDate>{formatDate(memo.createdAt)}</MemoDate>
                  </MemoItem>
                ))}
              </>
            ) : (
              <div style={{textAlign: 'center', color: '#888', padding: '40px 0'}}>
                아직 메모가 없습니다.
              </div>
            )}
          </div>
        )}
      </TabContent>
      {loadingMore && <LoadingOverlay isLoading={loadingMore} />}
      {memoLoadingMore && <LoadingOverlay isLoading={memoLoadingMore} />}
    </PageWrapper>
  );
} 